import styled from 'styled-components';
import { Checkbox } from 'antd';

export const StyledCheckboxGroup = styled(Checkbox.Group)`
  .ant-checkbox-wrapper.ant-checkbox-group-item {
    display: block;
  }

  .ant-checkbox {
    display: inline-block;
  }
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
`;
